import { Text } from "@mantine/core";
import { openConfirmModal } from "@mantine/modals";
import i18n from "i18next";
import classes from "../components/ui/app-modal.module.css";

export const Dialog = {
  confirm: (text: string, callback: (key: "confirm" | "cancel") => void) =>
    openConfirmModal({
      title: i18n.t("confirm", { ns: "common" }),
      children: <Text size="sm">{text}</Text>,
      labels: {
        confirm: i18n.t("yes", { ns: "common" }),
        cancel: i18n.t("no", { ns: "common" }),
      },
      confirmProps: { color: "red" },
      cancelProps: { variant: "default" },
      classNames: {
        title: classes.confirmTitle,
        body: classes.confirmModalBody,
        header: classes.modalHeader,
      },
      onCancel: () => callback("cancel"),
      onConfirm: () => callback("confirm"),
      centered: true,
    }),
};
